let modalLayerDepth = 0;

function syncDockInert() {
  const dock = document.querySelector('.dock-nav');
  if (!dock) return;
  if (document.documentElement.classList.contains('modal-open')) {
    dock.setAttribute('inert', '');
  } else {
    dock.removeAttribute('inert');
  }
}

function blurDockFocus() {
  const active = document.activeElement;
  if (active instanceof HTMLElement && active.closest('.dock-nav')) {
    active.blur();
  }
}

export function pushModalLayer(): () => void {
  modalLayerDepth += 1;
  document.documentElement.classList.add('modal-open');
  syncDockInert();
  return () => {
    modalLayerDepth = Math.max(0, modalLayerDepth - 1);
    if (modalLayerDepth === 0) {
      document.documentElement.classList.remove('modal-open');
      syncDockInert();
      window.requestAnimationFrame(() => {
        blurDockFocus();
      });
    }
  };
}
